import React, {useEffect, useState} from 'react';

import ShimmerComponent from '../../shimmerComponent/shimmerComponent';
import {withWhiteLabelContext} from '../../../../screens/ExpertHome/WhiteLabelContextProvider';

import utilsService from '../../../../services/utilsService';
import VIDABOO_CONSTANTS from '../../../../config/consts';

import './consoltoLogoComponent.css';

const ConsoltoLogoComponent = ({whiteLabelContext = {}}) => {
  const [logoPhotoDto, setLogoPhotoDto] = useState(null);

  useEffect(() => {
    const photoDto = utilsService.getPhotoDtoAndIdxByPhotoAndObjectType(
      whiteLabelContext.agencyPhotoDtos,
      VIDABOO_CONSTANTS.PHOTO_TYPES.BACKGROUND,
      VIDABOO_CONSTANTS.PHOTO_OBJECT_TYPES.RESELLERAGENCY,
    )?.photoDto;

    setLogoPhotoDto(photoDto);
  }, [whiteLabelContext.agencyPhotoDtos]);

  const logoUrl = logoPhotoDto?.photoUrl || '';
  const shouldApplyColorFilter = logoPhotoDto?.isDefaultPhoto === true;
  const shouldShowShimmer = !whiteLabelContext.isAgencyInfoFetched || !logoUrl;

  return shouldShowShimmer ? (
    <div className="et-consolto-logo-container">
      <ShimmerComponent />
    </div>
  ) : (
    <img
      className={`et-consolto-logo-image ${shouldApplyColorFilter ? 'et-main-color-filter' : 'et-consolto-logo-with-border-radius'}`}
      src={logoUrl}
      alt="Logo"
    />
  );
};

export default withWhiteLabelContext(ConsoltoLogoComponent);
